import { render, staticRenderFns } from "./botaoGaleria.vue?vue&type=template&id=1959be6e&scoped=true&"
import script from "./botaoGaleria.vue?vue&type=script&lang=js&"
export * from "./botaoGaleria.vue?vue&type=script&lang=js&"
import style0 from "./botaoGaleria.vue?vue&type=style&index=0&id=1959be6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1959be6e",
  null
  
)

export default component.exports